var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _setup.isShared
      ? _c(
          "div",
          { staticClass: "jumbotron" },
          [
            _c("h1", { staticClass: "display-4" }, [
              _vm._v("Shares of " + _vm._s(_setup.resourceName)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "lead" }, [
              _vm._v("You shared "),
              _c("strong", [_vm._v(_vm._s(_setup.resourceName))]),
              _vm._v(" owned by "),
              _c("strong", [_vm._v(_vm._s(_setup.organizationName))]),
              _vm._v(" data in TransparentChoice application"),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._l(_setup.sharesExt, function (s) {
              return _c("div", { key: s.Id }, [
                s.IsPaused
                  ? _c("div", { staticClass: "row text-muted" }, [
                      _c("div", { staticClass: "col-sm-9" }, [
                        _vm._v(
                          "\n                    " + _vm._s(s.Title) + " "
                        ),
                        _c("span", { staticClass: "fg-color-orange" }, [
                          _vm._v("(paused)"),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", [_vm._v(_vm._s(s.ShareUrl))]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-primary pull-right",
                            attrs: {
                              href: `/#/sharing/share/${_setup.resourceProviderName}/${_setup.resourceId}/${s.ShareId}`,
                            },
                          },
                          [_vm._v("Manage")]
                        ),
                      ]),
                    ])
                  : s.Expired
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-9 text-muted" }, [
                        _vm._v(
                          "\n                    " + _vm._s(s.Title) + " "
                        ),
                        _c("span", { staticClass: "fg-color-red" }, [
                          _vm._v("(expired)"),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", [_vm._v(_vm._s(s.ShareUrl))]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-primary pull-right",
                            attrs: {
                              href: `/#/sharing/share/${_setup.resourceProviderName}/${_setup.resourceId}/${s.ShareId}`,
                            },
                          },
                          [_vm._v("Manage")]
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-9" }, [
                        _vm._v("\n                    " + _vm._s(s.Title)),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-control bg-white",
                              class: { "text-success": s.Copied },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: s.Copied ? "COPIED!" : s.ShareUrl,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _setup.handleCopyToClipboard(s)
                                    },
                                  },
                                },
                                [_c("span", { staticClass: "fa fa-copy" })]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              href: `/#/sharing/share/${_setup.resourceProviderName}/${_setup.resourceId}/${s.ShareId}`,
                            },
                          },
                          [_vm._v("Manage")]
                        ),
                        _vm._v(" "),
                        s.SharedWith?.length > 0
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  href: `/#/sharing/share/notification/${s.ShareId}`,
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular fa-paper-plane",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                _vm._v(" "),
                _c("hr"),
              ])
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-lg btn-secondary",
                attrs: { href: _setup.manageUrl },
              },
              [_vm._v("Go to " + _vm._s(_setup.resourceName))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-lg btn-success pull-right",
                attrs: {
                  href: `/#/sharing/share/${_setup.resourceProviderName}/${_setup.resourceId}/${_setup.newShareId}`,
                },
              },
              [_vm._v("New Share")]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }